module.exports = __webpack_public_path__ + "img/icon-ai-xiaojie@2x.da09bc5e.png";